import React from 'react';
import './DefaultView.css';
import DeliverySiteHeader from '../components/DeliverySiteHeader';
import DeliverySiteBody from '../components/DeliverySiteBody';
import NotificationBar from '../components/NotificationBar';

const DefaultView = (props) => {
  const isFirstLoad = props.isFirstLoad;
  const loadingMessage = props.loadingMessage;
  const theDeliverySite = props.theDeliverySite;
  const locationCode = props.locationCode;
  const notificationMessage = props.notificationMessage;

  // render
  return (
    <div className="DefaultView">
      <DeliverySiteHeader
        theDeliverySite={theDeliverySite}
        locationCode={locationCode}
        loadingMessage={loadingMessage}
        isFirstLoad={isFirstLoad} />
      <NotificationBar
        notificationMessage={notificationMessage} />
      <DeliverySiteBody
        theDeliverySite={theDeliverySite}
        isFirstLoad={isFirstLoad} />
    </div>
  );
}

export default DefaultView;
